(function () {
  var btn = document.getElementById('back-to-top');
  if (!btn) return;

  function toggle() {
    var threshold = window.innerHeight;
    if (window.scrollY > threshold) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', toggle, { passive: true });
  toggle();

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
